/* eslint-disable */
/* eslint-disable import/prefer-default-export */

export const FILTER_PERSIST_KEY = `bds:filter`;

export const FILTER_DEFAULT_NUMBER_OF_DAYS = 7;
